import { render, staticRenderFns } from "./ProviderError.vue?vue&type=template&id=5e13dd75&scoped=true&"
import script from "./ProviderError.vue?vue&type=script&lang=ts&"
export * from "./ProviderError.vue?vue&type=script&lang=ts&"
import style0 from "./ProviderError.vue?vue&type=style&index=0&id=5e13dd75&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e13dd75",
  null
  
)

export default component.exports